const STORAGE_KEY = 'NEWS_NAV_LIST'

export function normalizeNewsNavItem(item) {
  if (!item || item.id == null || item.id === '') return null
  return {
    id: String(item.id),
    title: item.title || '',
    date: item.date || item.publishDate || item.publishTime || '',
    source: item.source || '',
    content: item.content || ''
  }
}

/** 列表页进入详情前写入，供详情页计算上一篇/下一篇 */
export function setNewsNavList(list) {
  try {
    const normalized = (Array.isArray(list) ? list : [])
      .map(normalizeNewsNavItem)
      .filter(Boolean)
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(normalized))
  } catch (e) {
    // ignore
  }
}

export function getNewsNavList() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const list = JSON.parse(raw)
    return (Array.isArray(list) ? list : [])
      .map(normalizeNewsNavItem)
      .filter(Boolean)
  } catch (e) {
    return []
  }
}

export function findNewsNavIndex(list, id) {
  const sid = String(id || '')
  if (!sid || !list.length) return -1
  return list.findIndex((item) => String(item.id) === sid)
}

export function getNewsNavNeighbors(list, id) {
  const index = findNewsNavIndex(list, id)
  if (index < 0) {
    return { index: -1, prev: null, next: null }
  }
  return {
    index,
    prev: index > 0 ? list[index - 1] : null,
    next: index < list.length - 1 ? list[index + 1] : null
  }
}
